import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Circle({
  iconSize,
  iconAccessibilityLabel,
  iconColor,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M12 22.9998C18.0751 22.9998 23 18.0749 23 11.9998C23 5.92462 18.0751 0.999756 12 0.999756C5.92487 0.999756 1 5.92462 1 11.9998C1 18.0749 5.92487 22.9998 12 22.9998ZM12 23.9998C18.6274 23.9998 24 18.6272 24 11.9998C24 5.37234 18.6274 -0.000244141 12 -0.000244141C5.37258 -0.000244141 0 5.37234 0 11.9998C0 18.6272 5.37258 23.9998 12 23.9998Z"
        fill={iconColor}
      />
    </Svg>
  );
}
